import { genderList, regions, ROUTE_PATH, UPLOADED_FILTER, YEAR_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaSelectModel } from "common/models/utility-models/meta-model";

export class DocumentFilterMetaModel extends FormMetaModel {
    constructor() {
        super('', ROUTE_PATH.reports, ROUTE_PATH.reports, 3, null,false,'','','row align-items-start');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const selectedBatch = new SmMetaSelectModel(
            'selectedBatch',
            'selectedBatch',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            4,
            'Batch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'batch_number',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true

        );
        const selectedRegion = new SmMetaSelectModel(
            'selectedRegion',
            'selectedRegion',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            5,
            'Region',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            regions,
            'name',
            'value',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedState = new SmMetaSelectModel(
            'selectedState',
            'selectedState',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            6,
            'State',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'stateName',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedBranch = new SmMetaSelectModel(
            'selectedBranch',
            'selectedBranch',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            7,
            'Branch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'department_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedGender = new SmMetaSelectModel(
            'selectedGender',
            'selectedGender',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            8,
            'Gender',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            genderList,
            'name',
            'value',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedDocumentType = new SmMetaSelectModel(
            'selectedDocumentType',
            'selectedDocumentType',
            'select',
            true,
            'col-2-4 pt-2',
            1,
            1,
            'Type',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [{ id: 0, name: 'Semi-Annual' }, { id: 1, name: 'Annual' }],
            'name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true

        );
        const selectedPeriod = new SmMetaSelectModel(
            'selectedPeriod',
            'selectedPeriod',
            'select',
            true,
            'col-2-4 pt-2',
            1,
            2,
            'Year/Semesters',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedDocument = new SmMetaSelectModel(
            'selectedDocument',
            'selectedDocument',
            'select',
            true,
            'col-2-4 pt-2',
            1,
            3,
            'Document',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'document_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );

        const selectedUploadFilter = new SmMetaSelectModel(
            'selectedUploadFilter',
            'selectedUploadFilter',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            9,
            'Uploaded Result',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            UPLOADED_FILTER,
            'name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );


        return {
            formInfo,
            selectedDocumentType,
            selectedPeriod,
            selectedDocument,
            selectedBatch,
            selectedBranch,
            selectedGender,
            selectedRegion,
            selectedState,
            selectedUploadFilter
        }
    }
}